// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingNew_loadingContainer__0DxEA","animationContainer":"LoadingNew_animationContainer__ZGUXM","animation":"LoadingNew_animation__l1F49"};